import { render, staticRenderFns } from "./DemoDialog.vue?vue&type=template&id=5475e892&scoped=true"
import script from "./DemoDialog.vue?vue&type=script&lang=js"
export * from "./DemoDialog.vue?vue&type=script&lang=js"
import style0 from "./DemoDialog.vue?vue&type=style&index=0&id=5475e892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475e892",
  null
  
)

export default component.exports